import { ADD_PROPERTY, ADD_TEAM_MEMBER,
    ADD_LANDLORD, UPDATE_LANDLORD, DELETE_LANDLORD,
    ADD_TENANT, UPDATE_TENANT, DELETE_TENANT,
    ADD_UNIT, UPDATE_UNIT, DELETE_UNIT, UPDATE_PROPERTY,
    BULK_UPLOAD, DELETE_PROPERTY, DELETE_TEAM_MEMBER,
    ADD_INVOICE, UPDATE_INVOICE,
    ADD_PAYMENT, UPDATE_PAYMENT, DELETE_PAYMENTS,
    UPDATE_TEAM_MEMBER, ADD_EXPENSE, UPDATE_EXPENSE, DELETE_EXPENSE,
    FEATURE_COMING_SOON, LOG_OUT_USER, REMOVE_MODAL, SEND_MESSAGE,
    SHOW_ERROR, SHOW_CUSTOM_ERROR,
    ADD_UNIT_UTILITY, UPDATE_UNIT_UTILITY, DELETE_UNIT_UTILITY,
    ADD_MAINTENANCE, UPDATE_MAINTENANCE, DELETE_MAINTENANCE,
    NO_TENANT_IN_UNIT, SEND_INVOICE, SEND_PAYMENT_RECEIPT,
    SEND_PAYMENT_REMINDER, SEND_TENANT_STATEMENT,
    UPLOAD_BULK_TRANSACTIONS, CREATE_PROPERTY_INVOICES, ADD_UTILITIES_BULK,
    GET_TENANT_IN_UNIT, INVALID_UTILITY_RATE, FEEDBACK_MESSAGE,
    PASSWORD_RESET, ASSIGN_PAYMENT, UPDATE_SETTINGS, UPDATE_CURRENCY,
    SEND_BULK_PAYMENT_REMINDER, SHIFT_TENANT, REALLOCATE_PAYMENT,
    BULK_CREATE_UTILITY_INVOICES, ADD_BANK_ACCOUNT, UPDATE_BANK_ACCOUNT,
    DELETE_BANK_ACCOUNTS, FETCH_STATEMENT_BANK_ACCOUNT,
    DOWNLOAD_INVOICE_OR_RECEIPT, DOWNLOAD_TRANSACTIONS,
    DELETE_INVOICES,
    MPESA_STK, ADD_WITHDRAWALS_BANK_ACCOUNTS, ADD_WITHDRAWALS_MOBILE_ACCOUNTS,
    UPDATE_WITHDRAWALS_BANK_ACCOUNTS, UPDATE_WITHDRAWALS_MOBILE_ACCOUNTS,
    DELETE_WITHDRAWALS_BANK_ACCOUNTS, DELETE_WITHDRAWALS_MOBILE_ACCOUNTS,
    UPDATE_TIMEZONE, CANCEL_WITHDRAWAL_REQUEST, WITHDRAWAL_REQUEST, RESEND_MESSAGE, DECLINE_ONBOARDING,
    UPDATE_PREFERENCES, SET_DEFAULT_PREFERENCES, UPDATE_SMS_ALERT_PREFERENCES, UPDATE_SURVEY,
    RESET_UTILITIES, INITIALIZE_PAYSTACK_TRANSACTION, CANCEL_CARD_SUBSCRIPTION,
    CALCULATE_BULK_INVOICES,
    CREATE_BULK_INVOICES
} from "../../actions/actionTypes";

import { SEND_TENANT_OTP } from "../../tenantApp/actions/actionTypes";


let initialState = {
    open: false,
    title: '',
    body: ''
}

const setModalState = ( open, title, body, color="dark") => {
    if (!(typeof body === 'string' || body instanceof String)){
        body = "";
    }
    return {
        open: open,
        title: title,
        body: body,
        color
    }
}

const feedbackModalReducer = (state=initialState, action) => {
    let  feedbackModalState = state;

    if (action.errors == null){
        switch(action.type){
            case ADD_PROPERTY:
                return setModalState(true, 'Success', 'Property Added Successfully', "success");
            case UPDATE_PROPERTY:
                return setModalState(true, 'Success', 'Property Updated Successfully', "success");
            case DELETE_PROPERTY:
                return setModalState(true, 'Success', 'Property Deleted Successfully', "success");
            case ADD_UNIT:
                return setModalState(true, 'Success', 'Unit Added Successfully', "success");
            case UPDATE_UNIT:
                return setModalState(true, 'Success', 'Unit Updated Successfully', "success");
            case DELETE_UNIT:
                return setModalState(true, 'Success', 'Unit Deleted Successfully', "success");
            case ADD_LANDLORD:
                return setModalState(true, 'Success', 'Landlord Added Successfully', "success");
            case UPDATE_LANDLORD:
                    return setModalState(true, 'Success', 'Landlord Updated Successfully', "success");
            case DELETE_LANDLORD:
                    return setModalState(true, 'Success', 'Landlord Deleted Successfully', "success");
            case ADD_TENANT:
                return setModalState(true, 'Success', 'Tenant Added Successfully', "success");
            case UPDATE_TENANT:
                return setModalState(true, 'Success', 'Tenant Updated Successfully', "success");
            case DELETE_TENANT:
                return setModalState(true, 'Success', 'Tenant Deleted Successfully', "success");
            case ADD_EXPENSE:
                return setModalState(true, 'Success', 'Expense Added Successfully', "success");
            case UPDATE_EXPENSE:
                return setModalState(true, 'Success', 'Expense Updated Successfully', "success");
            case DELETE_EXPENSE:
                return setModalState(true, 'Success', 'Expense Deleted Successfully', "success");
            case REMOVE_MODAL:
                return initialState
            case BULK_UPLOAD:
                return setModalState(true, 'Success', 'All Data has been uploaded Successfully', "success");
            case ADD_INVOICE:
                return setModalState(true, 'Success', 'Invoice Added Successfully', "success");
            case UPDATE_INVOICE:
                return setModalState(true, 'Success', 'Invoice updated Successfully', "success");
            case DELETE_INVOICES:
                return setModalState(true, 'Success', 'Invoice(s) deleted Successfully', "success");
            case MPESA_STK:
                return setModalState(true, 'Success', 'A payment prompt sent to your phone', "success");
            case ADD_PAYMENT:
                if (action.payload.sendReceipt) {
                    return setModalState(true, 'Success', 'Payment added successfully. A receipt will be sent.', "success");
                }
                return setModalState(true, 'Success', 'Payment Added Successfully', "success");
            case UPDATE_PAYMENT:
                if (action.payload.sendReceipt) {
                    return setModalState(true, 'Success', 'Payment updated successfully. A receipt will be sent.', "success");
                }
                return setModalState(true, 'Success', 'Payment updated Successfully', "success");
            case DELETE_PAYMENTS:
                return setModalState(true, 'Success', 'Payment deleted Successfully', "success");ß
            case ADD_TEAM_MEMBER:
                return setModalState(true, 'Success', 'Team Member Added Successfully', "success");
            case UPDATE_TEAM_MEMBER:
                return setModalState(true, 'Success', 'Team Member Updated Successfully', "success");
            case DELETE_TEAM_MEMBER:
                return setModalState(true, 'Success', 'Team Member Deleted Successfully', "success");
            case ADD_UNIT_UTILITY:
                return setModalState(true, 'Success', 'Unit Utility Added Successfully', "success");
            case UPDATE_UNIT_UTILITY:
                return setModalState(true, 'Success', 'Unit Utility Updated Successfully', "success");
            case DELETE_UNIT_UTILITY:
                return setModalState(true, 'Success', 'Unit Utility Deleted Successfully', "success");
            case ADD_WITHDRAWALS_BANK_ACCOUNTS:
                return setModalState(true, 'Success', 'Added Bank Account(s) Successfully', "success");
            case ADD_WITHDRAWALS_MOBILE_ACCOUNTS:
                return setModalState(true, 'Success', 'Added Mobile Account(s) Successfully', "success");
            case UPDATE_WITHDRAWALS_BANK_ACCOUNTS:
                return setModalState(true, 'Success', 'Updated Bank Account(s) Successfully', "success");
            case UPDATE_WITHDRAWALS_MOBILE_ACCOUNTS:
                return setModalState(true, 'Success', 'Updated Mobile Account(s) Successfully', "success");
            case DELETE_WITHDRAWALS_BANK_ACCOUNTS:
                return setModalState(true, 'Success', 'Deleted Bank Account(s) Successfully', "success");
            case DELETE_WITHDRAWALS_MOBILE_ACCOUNTS:
                return setModalState(true, 'Success', 'Deleted Mobile Account(s) Successfully', "success");
            case UPDATE_SURVEY:
                return setModalState(true, 'Success', 'Survey Completed Successfully', "success");
            case LOG_OUT_USER:
                return {};
            case FEATURE_COMING_SOON:
                return setModalState(true, 'Coming Soon', 'Feature Coming Soon');
            case SEND_MESSAGE:
                return setModalState(true, 'Success', action.payload.message, "success");
            case RESEND_MESSAGE:
                return setModalState(true, 'Success', action.payload.message, "success");
            case SEND_INVOICE:
                return setModalState(true, 'Success', action.payload.message, "success");
            case SEND_TENANT_STATEMENT:
                return setModalState(true, 'Success', action.payload.message, "success");
            case SEND_PAYMENT_RECEIPT:
                return setModalState(true, 'Success', action.payload.message, "success");
            case SEND_PAYMENT_REMINDER:
                return setModalState(true, 'Success', action.payload.message, "success");
            case CALCULATE_BULK_INVOICES:
                return setModalState(true, 'Success', action.payload.message, "success");
            case CREATE_BULK_INVOICES:
                return setModalState(true, 'Success', action.payload.message, "success");
            case ADD_MAINTENANCE:
                return setModalState(true, 'Success', 'Maintenance record added Successfully', "success");
            case UPDATE_MAINTENANCE:
                return setModalState(true, 'Success', 'Maintenance record updated Successfully', "success");
            case DELETE_MAINTENANCE:
                return setModalState(true, 'Success', 'Maintenance record deleted Successfully', "success");
            case UPLOAD_BULK_TRANSACTIONS:
                return setModalState(true, 'Success', 'Transactions uploaded Successfully', "success");
            case CREATE_PROPERTY_INVOICES:
                return setModalState(true, 'Success', 'All rent invoices for the month have been generated Successfully', "success");
            case ADD_UTILITIES_BULK:
                return setModalState(true, 'Success', 'Utilities added Successfully', "success");
            case PASSWORD_RESET:
                return setModalState(true, 'Success', 'Password reset was successful', "success");
            case ASSIGN_PAYMENT:
                return setModalState(true, 'Success', 'Payment assigned Successfully', "success");
            case REALLOCATE_PAYMENT:
                return setModalState(true, 'Success', 'Payment re-allocated Successfully', "success");
            case UPDATE_SETTINGS:
                return setModalState(true, 'Success', 'Settings updated Successfully', "success");
            case UPDATE_PREFERENCES:
                return setModalState(true, 'Success', 'Alert preferences updated Successfully', "success");
            case SET_DEFAULT_PREFERENCES:
                return setModalState(true, 'Success', 'Alert preferences reset to default Successfully', "success");
            case UPDATE_CURRENCY:
                return setModalState(true, 'Success', 'Currency updated Successfully', "success");
            case UPDATE_TIMEZONE:
                return setModalState(true, 'Success', 'Timezone updated Successfully', "success");
            case SHIFT_TENANT:
                return setModalState(true, 'Success', 'Tenant shifted Successfully', "success");
            case ADD_BANK_ACCOUNT:
                return setModalState(true, 'Success', 'Bank Account added Successfully', "success");
            case UPDATE_BANK_ACCOUNT:
                return setModalState(true, 'Success', 'Bank Account updated Successfully', "success");
            case DELETE_BANK_ACCOUNTS:
                return setModalState(true, 'Success', 'Bank Account deleted Successfully', "success");
            case FETCH_STATEMENT_BANK_ACCOUNT:
                return setModalState(true, 'Success', 'Fetched Bank Account Statement Successfully', "success");
            case DOWNLOAD_INVOICE_OR_RECEIPT:
                return setModalState(true, 'Success', 'Download succeeded', "success")
            case DOWNLOAD_TRANSACTIONS:
                return setModalState(true, 'Success', 'Download succeeded', "success")
            case CANCEL_WITHDRAWAL_REQUEST:
                return setModalState(true, 'Success', 'Withdrawal Request cancelled Successfully', "success")
            case WITHDRAWAL_REQUEST:
                return setModalState("true", 'Success', action.successMessage, "success")
            case UPDATE_SMS_ALERT_PREFERENCES:
                return setModalState(true, 'Success', 'Message Alert Preferences updated Successfully', "success");
            case SEND_BULK_PAYMENT_REMINDER:
                return setModalState(true, 'Success', action.payload.message, "success");
            case FEEDBACK_MESSAGE:
                return setModalState(true, action.payload.title, action.payload.message, "success");
            case SEND_TENANT_OTP:
                return setModalState(true, "Success", action.payload.successMessage, "success");
            case DECLINE_ONBOARDING:
                return setModalState(true, "Success", "Onboarding skipped successfully");
            case RESET_UTILITIES:
                return setModalState(true, "Success", action.payload.message, "success");
            case INITIALIZE_PAYSTACK_TRANSACTION:
                return setModalState(true, "Success", "Payment transaction initialized successfully", "success");
            case CANCEL_CARD_SUBSCRIPTION:
                return setModalState(true, "Success", action.payload.message, "success");

            default:
                return feedbackModalState;
        }
    }else{
        switch(action.type){
            case SHOW_ERROR:
                return setModalState(true, 'Error', 'An error occurred. Please ensure your internet connection is good', "danger");
            case SHOW_CUSTOM_ERROR:
                if (action.errors){
                    return setModalState(true, "Failed", action.errors, "danger");
                }else{
                    return feedbackModalState;
                }

            case SEND_MESSAGE:
                return setModalState(true, 'Failed', action.errors, "danger");
            case DECLINE_ONBOARDING:
                return setModalState(true, 'Failed', action.errors, "danger");
            case RESEND_MESSAGE:
                return setModalState(true, 'Failed', action.errors, "danger");
            case SEND_INVOICE:
                return setModalState(true, 'Failed', action.errors, "danger");
            case SEND_TENANT_STATEMENT:
                return setModalState(true, 'Failed', action.errors, "danger");
            case SEND_PAYMENT_RECEIPT:
                return setModalState(true, 'Failed', action.errors, "danger");
            case SEND_PAYMENT_REMINDER:
                return setModalState(true, 'Failed', action.errors, "danger");
            case MPESA_STK:
                return setModalState(true, 'Failed', action.errors, "danger");
            case NO_TENANT_IN_UNIT:
                return setModalState(true, 'Failed', action.errors, "danger");
            case CALCULATE_BULK_INVOICES:
                return setModalState(true, 'Failed', action.errors, "danger");
            case CREATE_BULK_INVOICES:
                return setModalState(true, 'Failed', action.errors, "danger");
            case ADD_UNIT_UTILITY:
                return setModalState(true, 'Failed', action.errors, "danger");
            case DELETE_UNIT_UTILITY:
                return setModalState(true, 'Failed', 'Cannot delete a utility with a related invoice', "warning");
            case UPLOAD_BULK_TRANSACTIONS:
                return setModalState(true, 'Failed', action.errors, "danger");
            case ADD_UNIT:
                return setModalState(true, 'Failed', action.errors, "danger");
            case CREATE_PROPERTY_INVOICES:
                return setModalState(true, 'Failed', action.errors, "danger");
            case ADD_UTILITIES_BULK:
                return setModalState(true, 'Failed', action.errors, "danger");
            case GET_TENANT_IN_UNIT:
                return setModalState(true, 'Failed', action.errors, "danger");
            case INVALID_UTILITY_RATE:
                return setModalState(true, 'Failed', action.errors, "danger");
            case ADD_TEAM_MEMBER:
                return setModalState(true, 'Failed', action.errors, "danger");
            case UPDATE_TEAM_MEMBER:
                return setModalState(true, 'Failed', action.errors, "danger");
            case DELETE_TEAM_MEMBER:
                return setModalState(true, 'Failed', action.errors, "danger");
            case ASSIGN_PAYMENT:
                return setModalState(true, 'Failed', 'Could not assign payment to tenant', "danger");
            case REALLOCATE_PAYMENT:
                return setModalState(true, 'Failed', 'Could not re-allocate payment to tenant', "danger");
            case BULK_CREATE_UTILITY_INVOICES:
                return setModalState(true, 'Failed', "Could not create utility invoices", "danger");
            case SHIFT_TENANT:
                return setModalState(true, 'Failed', action.errors, "danger");
            case ADD_WITHDRAWALS_BANK_ACCOUNTS:
                return setModalState(true, 'Failed', action.errors, "danger");
            case ADD_WITHDRAWALS_MOBILE_ACCOUNTS:
                return setModalState(true, 'Failed', action.errors, "danger");
            case UPDATE_WITHDRAWALS_BANK_ACCOUNTS:
                return setModalState(true, 'Failed', action.errors, "danger");
            case UPDATE_WITHDRAWALS_MOBILE_ACCOUNTS:
                return setModalState(true, 'Failed', action.errors, "danger");
            case DELETE_WITHDRAWALS_BANK_ACCOUNTS:
                return setModalState(true, 'Failed', action.errors, "danger");
            case DELETE_WITHDRAWALS_MOBILE_ACCOUNTS:
                return setModalState(true, 'Failed', action.errors, "danger");
            case UPDATE_PREFERENCES:
                return setModalState(true, 'Failed', action.errors, "danger");
            case SET_DEFAULT_PREFERENCES:
                return setModalState(true, 'Failed', action.errors, "danger");
            case UPDATE_SMS_ALERT_PREFERENCES:
                return setModalState(true, 'Failed', action.errors, "danger");
            case UPDATE_SURVEY:
                return setModalState(true, 'Failed', action.errors, "danger");
            case RESET_UTILITIES:
                return setModalState(true, 'Failed', action.errors, "danger");
            case INITIALIZE_PAYSTACK_TRANSACTION:
                return setModalState(true, 'Failed', action.errors, "danger");
            case CANCEL_CARD_SUBSCRIPTION:
                return setModalState(true, 'Failed', action.errors, "danger");
            default:
                if(action.errors && typeof action.errors === 'string' || action.errors instanceof String){
                    return setModalState(true, 'Failed', action.errors);
                }
                else if(Array.isArray(action.errors) && action.errors.length > 0
                    && 'message'in action.errors[0] &&
                    action.errors[0]["message"] == "You do not have permission to perform this action"){
                        return initialState;
                }else if(Array.isArray(action.errors) && action.errors.length > 0
                && 'message' in action.errors[0]){
                    return setModalState(true, 'Failed', action.errors[0]["message"], "danger");;
                }
                else{
                    return setModalState(true, 'Failed', 'Operation Failed', "danger");
                }

        }
    }


};

export default feedbackModalReducer;